import mainImageHomeCroppedMobile from "../images/main-image-home-cropped-mobile.jpg";
import mainImageHomeCroppedTablet from "../images/main-image-home-cropped-tablet.jpg";
import mainImageHome from "../images/main-image-home.jpg";

import mainImageSection1CroppedMobile from "../images/main-image-1-section-cropped-mobile.jpg";
import mainImageSection1Croppedtablet from "../images/main-image-1-section-cropped-tablet.jpg";
import mainImageSection1 from "../images/main-image-1-section.jpg";

import mainImageSection2CroppedMobile from "../images/main-image-2-section-cropped-mobile.jpg";
import mainImageSection2Croppedtablet from "../images/main-image-2-section-cropped-tablet.jpg";
import mainImageSection2 from "../images/main-image-2-section.jpg";

import mainImageSection3CroppedMobile from "../images/main-image-3-section-cropped-mobile.jpg";
import mainImageSection3Croppedtablet from "../images/main-image-3-section-cropped-tablet.jpg";
import mainImageSection3 from "../images/main-image-3-section.jpg";

import mainImageSection4CroppedMobile from "../images/main-image-4-section-xx-cropped-mobile.jpg";
// import mainImageSection4CroppedMobile from "../images/main-image-4-section-cropped-mobile.jpg";
// import mainImageSection4Croppedtablet from "../images/main-image-4-section-cropped-tablet.jpg";
import mainImageSection4Croppedtablet from "../images/main-image-4-section-xx-cropped-tablet.jpg";
import mainImageSection4 from "../images/main-image-4-section-xx.jpg";

import mainImageSection5CroppedMobile from "../images/main-image-5-section-x-cropped-mobile.jpg";
import mainImageSection5Croppedtablet from "../images/main-image-5-section-x-cropped-tablet.jpg";
import mainImageSection5 from "../images/main-image-5-section-x.jpg";

// import mainImageSection6CroppedMobile from "../images/main-image-6-section-cropped-mobile.jpg";
import mainImageSection6CroppedMobile from "../images/main-image-6-section-x-cropped-mobile.jpg";
// import mainImageSection6Croppedtablet from "../images/main-image-6-section-cropped-tablet.jpg";
import mainImageSection6Croppedtablet from "../images/main-image-6-section-x-cropped-tablet.jpg";
// import mainImageSection6 from "../images/main-image-6-section.jpg";
import mainImageSection6 from "../images/main-image-6-section-x.jpg";

import ProfileInter1 from "../images/profile-inter-1.png";
import ProfileInterActive1 from "../images/profile-inter-active-1.png";
import ProfileInter2 from "../images/profile-inter-2.png";
import ProfileInterActive2 from "../images/profile-inter-active-2.png";
import ProfileInter3 from "../images/profile-inter-3.png";
import ProfileInterActive3 from "../images/profile-inter-active-3.png";
import ProfileInter4 from "../images/profile-inter-4.png";
import ProfileInterActive4 from "../images/profile-inter-active-4.png";

//Awards
import firstAward from "../images/forbes.jpg";
import secondAward from "../images/international-finance.png";
import thirdAward from "../images/brandz.jpg";
// import fourthAward from "../images/award-international-business-magazine.png";
// import fifthAward from "../images/award-point-checkout-xxxx.png";

// Icons
import plusSignIcon from "../images/plus-sign.png";
import minusSignIcon from "../images/minus-sign.png";

import PencilShapeImage1 from "../images/solid.png";
import PencilShapeImage2 from "../images/support.png";
import PencilShapeImage3 from "../images/network.png";

import bulletGreen from "../images/bullet-green.png";
import bulletSecondary from "../images/bullet-secondary.png";
import bulletGray from "../images/bullet-gray.png";
import bulletGrayLight from "../images/bullet-light-gray.png";
import bulletSecondaryLight from "../images/bullet-light-secondary.png";

import facebookIcon from "../images/facebook.svg";
import instagramIcon from "../images/instagram.svg";
import linkedinIcon from "../images/linkedin.svg";
import snapchatIcon from "../images/snapchat.svg";
import twitterIcon from "../images/twitter.svg";
import youtubeIcon from "../images/youtube.svg";

// import PencilShapeImage2 from "../images/solid.png";
// import PencilShapeImage3 from "../images/solid.png";

// import mainImageSection1 from "../images/main-image-section-1.jpg";
// import mainImageSection2 from "../images/main-image-section-2.jpg";

// const homeImages = [
//   mainImageHome1XCropped,
//   mainImageHome2XCropped,
//   mainImageHome1X,
//   mainImageHome2X,
//   mainImageHome3X,
//   mainImageHome,
// ];

const homeImages = [
  mainImageHomeCroppedMobile,
  mainImageHomeCroppedTablet,
  mainImageHome,
];

const mainImagesSection1 = [
  mainImageSection1CroppedMobile,
  mainImageSection1Croppedtablet,
  mainImageSection1,
];

const mainImagesSection2 = [
  mainImageSection2CroppedMobile,
  mainImageSection2Croppedtablet,
  mainImageSection2,
];

const mainImagesSection3 = [
  mainImageSection3CroppedMobile,
  mainImageSection3Croppedtablet,
  mainImageSection3,
];

const mainImagesSection4 = [
  mainImageSection4CroppedMobile,
  mainImageSection4Croppedtablet,
  mainImageSection4,
];

const mainImagesSection5 = [
  mainImageSection5CroppedMobile,
  mainImageSection5Croppedtablet,
  mainImageSection5,
];

const mainImagesSection6 = [
  // mainImageSection5CroppedMobile,
  // mainImageSection5Croppedtablet,
  mainImageSection6CroppedMobile,
  mainImageSection6Croppedtablet,
  mainImageSection6,
];

const mainImages = [
  homeImages,
  mainImagesSection1,
  mainImagesSection2,
  mainImagesSection3,
  mainImagesSection4,
  mainImagesSection5,
  mainImagesSection6,
];

export const generalIcons = [plusSignIcon, minusSignIcon];

export const bankProfileInteractiveImages = [
  [ProfileInter1, ProfileInterActive1],
  [ProfileInter2, ProfileInterActive2],
  [ProfileInter3, ProfileInterActive3],
  [ProfileInter4, ProfileInterActive4],
];

export const awardsImages = [firstAward, secondAward, thirdAward];

export const pencilShapeImages = [
  PencilShapeImage1,
  null,
  PencilShapeImage2,
  null,
  PencilShapeImage3,
];

export const bulletImages = [
  bulletGrayLight,
  bulletSecondary,
  bulletGreen,
  bulletSecondaryLight,
  bulletGray,
];

export const getPreloadedImage = (sectionNumber) => {
  return mainImages[sectionNumber];
};

export const socialIcons = [
  linkedinIcon,
  twitterIcon,
  facebookIcon,
  instagramIcon,
  snapchatIcon,
  youtubeIcon,
];
